import {useEffect, useState} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IconButton, DialogTitle, Dialog } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { open, close } from "../../../redux/actions/modalActions";

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { FaInfoCircle } from "react-icons/fa";

import './UtiDetailsBox.css'

function UtiDetailsBox(props) {
  const dispatch = useDispatch();
 
  const [titles, setTitles] = useState({
    "id": 'מספר הזמנה',
    "uti_id" : 'מספר הזמנה',
    "date": 'תאריך הזמנה',
    "price": 'מחיר עסקה',
    "dealType": 'סוג עסקה',
    "oldLic" : 'שחלוף',
    "position": 'מבצע רישוי', 
    'modelName': 'דגם',
    'licNum': 'מספר רישוי',
    'chassisCode': 'מספר שילדה',
    'deliveryExpected': 'צפי אספקה',
    'boxSupp': 'ספק ארגז',
    'boxType': ' סוג ארגז',
    'boxLength' : 'אורך ארגז',
    'totalWithoutVat': 'סה"כ עסקה (לא כולל מע"מ)',
    'vat':'מע"מ',
    'tradeIn': 'טרייד אין',
    'paid': 'סה"כ שולם עד כה',
    'feeToPay':'תוספות להזמנה',
    'leftToPay' : 'סה"כ נותר לתשלום'
  })
  
  const elementMaxWidth = {
    maxWidth: props.width
  };

  return (
    <div className='details-box' style={elementMaxWidth}>
       <h4>{ props.title}
       {props.title === 'מצב חשבון' &&
        <FaInfoCircle cursor="pointer" onClick={(e) => dispatch(open("account_data"))} color="#000"/>
       }
       </h4>
      <Card className='details-card-x'>
        <CardContent className='cont-details-card'>
          <List className='det-list'>
            {props.items?.map(item => (
             (props.data && props.data[item] &&
             <ListItem alignItems="flex-start" disablePadding>               
                <ListItemText className='item-text'>
                  <span className='uti-card-title'>{titles[item]} {item === 'uti_id' ? <span className="english">UTI</span> : ''} {item === 'leftToPay' &&  props.data['feeToPay'] ? '(כולל רישוי)' : ''}</span>
                  <span className='uti-card-value'>{props.data ? props.data[item] || '' : ''}</span>
                </ListItemText>
               </ListItem>)
            ))}
           </List>
        </CardContent>
      </Card>
      </div>
    )
  
}

export default UtiDetailsBox
